import Vue from 'vue'
import Router from 'vue-router'
import { LoginCallback } from '@okta/okta-vue'

Vue.use(Router)
const metaRequireAuth = {
  requireAuth: true
}

let routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/home'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/callback',
    component: LoginCallback
  },
  {
    path: '/user/list',
    name: 'UserList',
    props: (route) => ({ currentPage: route.query.currentPage }),
    component: () => import('@/views/user/view'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/link/list',
    name: 'LinkList',
    component: () => import('@/views/link/view'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/link/:linkId',
    name: 'LinkDetails',
    component: () => import('@/views/link/edit'),
    meta: {
      breadcrumb: { name: 'SiteList', text: 'Retour aux liens' },
      requiresAuth: true
    }
  },
  {
    path: '/site/list',
    name: 'SiteList',
    component: () => import('@/views/site/view'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/site/:siteId',
    name: 'SiteDetails',
    component: () => import('@/views/site/details'),
    meta: {
      breadcrumb: { name: 'SiteList', text: 'Retour aux parcs' },
      requiresAuth: true
    }
  },
  {
    path: '/user/:userId',
    name: 'UserDetails',
    component: () => import('@/views/user/details'),
    meta: {
      breadcrumb: { name: 'UserList', text: 'Retour aux utilisateurs' },
      requiresAuth: true
    }
  },
  {
    path: '/video/list',
    name: 'VideoList',
    component: () => import('@/views/video/view'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/messages',
    name: 'MessagesIndex',
    component: () => import('@/views/messages/index'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/monitoring',
    name: 'MonitoringIndex',
    component: () => import('@/views/monitoring/index'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/notification/list',
    name: 'NotificationsList',
    component: () => import('@/views/notification/view'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/notification/:notificationId',
    name: 'NotificationDetails',
    component: () => import('@/views/notification/details'),
    meta: {
      breadcrumb: { name: 'NotificationsList', text: 'Retour aux notifications' },
      requiresAuth: true
    }
  },
  {
    name: 'Logout',
    path: '/Logout'
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('@/views/error/pageNotFound')
  },
  {
    path: '/forbiddenAccess',
    name: 'NotAllowed',
    component: () => import('@/views/error/pageNotAllowed')
  }
]

function SetMeta (route) {
  if (!route.meta) {
    route.meta = metaRequireAuth
  } else {
    Object.assign(route.meta, metaRequireAuth)
  }
}
routes.forEach(route => {
  if (!['NotAllowed', 'Logout'].includes(route.name)) {
    SetMeta(route)
    if (route.children) {
      route.children.forEach(children => {
        SetMeta(children)
      })
    }
  }
})

let router = new Router({
  mode: 'history',
  routes: routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js